/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import { useQuery } from 'react-query';
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Chip,
  Typography,
} from '@material-ui/core';
import { Add, Edit, Delete } from '@material-ui/icons';
import request from '../../../../services/network/request';
import { useAuth } from '../../../../auth/authProvider';
import RegraDescontoModal from './RegraDescontoModal';
import ConfirmDeleteModal from './ConfirmDeleteModal';

const ruleTypeLabels = {
  ENERGY_UTILITY: 'Distribuidora',
  PERSON_TYPE: 'Tipo de Pessoa',
  CONSUMPTION_RANGE: 'Faixa de Consumo (MW)',
};

const beneficiaryLabels = {
  REFERRER: 'Indicador',
  REFERRED: 'Indicado',
  BOTH: 'Ambos',
};

const RegraDesconto = () => {
  const { token } = useAuth();
  const [rules, setRules] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [currentRule, setCurrentRule] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState({ isOpen: false, id: '' });

  const { isFetching: isLoading, refetch } = useQuery(
    ['fetch-discount-rules'],
    () => {
      return request.get('discount-rules', { token });
    },
    {
      onSuccess: data => {
        setRules(data);
      },
    },
  );

  const handleOpenModal = (rule = null) => {
    setCurrentRule(rule);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setCurrentRule(null);
    setModalOpen(false);
  };

  const handleDeleteRule = async id => {
    try {
      await request.delete(`discount-rules/${id}`, { token });
      setOpenDeleteModal({ isOpen: false, id: '' });
      refetch();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Erro ao remover regra:', error);
    }
  };

  const getDisplayValue = rule => {
    if (rule.discountType === 'CONSUMPTION_RANGE') {
      if (rule.mwMinValue && rule.mwMaxValue) {
        return `${rule.mwMinValue} MW - ${rule.mwMaxValue} MW`;
      } else if (rule.mwMinValue) {
        return `≥ ${rule.mwMinValue} MW`;
      } else if (rule.mwMaxValue) {
        return `≤ ${rule.mwMaxValue} MW`;
      }
      return 'Qualquer valor';
    } else if (rule.discountType === 'PERSON_TYPE') {
      return rule.discountValue === 'JURIDICAL' ? 'Jurídica' : 'Física';
    }

    return rule.discountValue || 'Todos';
  };

  return (
    <>
      <Box display="flex" justifyContent="flex-end" mb={2}>
        <Button color="primary" onClick={() => handleOpenModal()} variant="contained" startIcon={<Add />}>
          NOVA REGRA
        </Button>
      </Box>

      <Paper elevation={2}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Tipo</TableCell>
                <TableCell>Valor</TableCell>
                <TableCell>Descrição</TableCell>
                <TableCell>Valor do Desconto (R$)</TableCell>
                <TableCell>Beneficiário</TableCell>
                <TableCell align="center">Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    Carregando...
                  </TableCell>
                </TableRow>
              ) : rules.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    Nenhuma regra encontrada
                  </TableCell>
                </TableRow>
              ) : (
                rules.map(rule => (
                  <TableRow key={rule.id}>
                    <TableCell>
                      <Typography variant="body2">{ruleTypeLabels[rule.discountType] || rule.discountType}</Typography>
                    </TableCell>
                    <TableCell>{getDisplayValue(rule)}</TableCell>
                    <TableCell>{rule.description}</TableCell>
                    <TableCell>R$ {rule.discountAmount}</TableCell>
                    <TableCell>
                      <Chip
                        label={beneficiaryLabels[rule.beneficiary] || rule.beneficiary}
                        color={rule.beneficiary === 'REFERRER' ? 'primary' : 'secondary'}
                        size="small"
                      />
                    </TableCell>
                    <TableCell align="center">
                      <IconButton size="small" color="primary" onClick={() => handleOpenModal(rule)}>
                        <Edit fontSize="small" />
                      </IconButton>
                      <IconButton
                        size="small"
                        color="secondary"
                        onClick={() => setOpenDeleteModal({ isOpen: true, id: rule.id })}
                      >
                        <Delete fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      <RegraDescontoModal open={modalOpen} onClose={handleCloseModal} rule={currentRule} refetch={refetch} />
      <ConfirmDeleteModal
        open={openDeleteModal.isOpen}
        onClose={() => setOpenDeleteModal({ isOpen: false, id: '' })}
        onSubmit={() => handleDeleteRule(openDeleteModal.id)}
      />
    </>
  );
};

export default RegraDesconto;
